import Env from '../base/env'

export default class Accordion
{
    constructor(view)
    {
        this.view = view
        this.$trigger = this.view.querySelector('.jsAccordion--trigger')
        this.$content = this.view.querySelector('.jsAccordion--content')
        this.heightOpen = 0
    }

    close()
    {
        TweenLite.to(this.$content , .4 , { height : 0 , ease : Cubic.easeOut , onStart:()=> {
                this.view.classList.remove('is--active')
            }
        })
    }

    events()
    {
        this.$trigger.addEventListener('mouseenter',()=>{
            this.open()
        })
        this.$trigger.addEventListener('mouseleave',()=>{
            this.close()
        })
    }

    open()
    {
        TweenLite.to(this.$content , .4 , { height : this.heightOpen , ease : Cubic.easeInOut , onStart:()=> {
                this.view.classList.add('is--active')
            }
        })
    }

    setSize()
    {
        if(this.$content != null) {
            this.heightOpen = this.$content.getBoundingClientRect().height
        }

    }

    setup()
    {
        if(this.$content != null) {
            this.setSize()
            this.$content.style.height = '0px'
            this.events()
            this.view.classList.add('jsAccordion--isReady')
        }

    }
}